// Mobile field-service helpers (CommonJS, dual-use: imported by src/App.jsx and
// unit-tested by node). Pure — no network, no DOM.

// The outcomes a process server picks at the door. Values are the codes the
// service_attempts.outcome check constraint already allows; only the labels are
// field-friendly. "Unable to Access" is the existing `inaccessible` code and
// "Moved / Does Not Live Here" the existing `wrong_address` code, so no schema
// change and no rewrite of historical attempts.
const FIELD_OUTCOMES = [
  { value: "served_personal", label: "Served — Personal" },
  { value: "served_substitute", label: "Served — Substitute" },
  { value: "no_answer", label: "No Answer" },
  { value: "refused", label: "Refused" },
  { value: "inaccessible", label: "Unable to Access" },
  { value: "wrong_address", label: "Moved / Does Not Live Here" },
  { value: "other", label: "Other" },
];
const FIELD_OUTCOME_VALUES = FIELD_OUTCOMES.map((o) => o.value);

// A served outcome implies the manner; anything else keeps the chosen manner.
function mannerForOutcome(outcome, chosenManner) {
  if (outcome === "served_substitute") return "substitute";
  if (outcome === "served_personal") return "personal";
  return chosenManner;
}

// The form "status" the rest of the capture form keys off (served sections,
// mailing, declaration preview) derived from the picked outcome.
function statusForOutcome(outcome) {
  return /^served_/.test(String(outcome || "")) ? "served" : "attempted";
}

// One maps link for the full service address. iPhone/iPad open Apple Maps;
// everything else uses Google's universal URL, which opens the Maps app on
// Android (and the browser elsewhere). No copy/paste.
function mapsUrl(address, zip, userAgent) {
  const a = String(address || "").trim();
  if (!a) return null;
  const z = String(zip || "").trim();
  const q = z && !a.includes(z) ? `${a} ${z}` : a;
  const ua = String(userAgent || "");
  if (/iPhone|iPad|iPod/i.test(ua)) return `https://maps.apple.com/?q=${encodeURIComponent(q)}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

// Today's local date/time for a fresh attempt (auto-captured, editable).
function nowLocalDateTime(d) {
  const t = d || new Date();
  const p = (n) => String(n).padStart(2, "0");
  return { date: `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`, time: `${p(t.getHours())}:${p(t.getMinutes())}` };
}

// CSS order for the mobile accordion: card i -> 2i, the selected order's
// details -> right after its own card.
function cardOrder(index) { return 2 * index; }
function detailOrder(selectedIndex) { return selectedIndex < 0 ? 100000 : 2 * selectedIndex + 1; }

module.exports = { FIELD_OUTCOMES, FIELD_OUTCOME_VALUES, mannerForOutcome, statusForOutcome, mapsUrl, nowLocalDateTime, cardOrder, detailOrder };
